<div class="avatar" [ngClass]="'avatar--' + size">
  <!-- <div class="avatar__initials" *ngIf="!image">{{getInitials()}}</div> -->
  <img class="avatar__image" src="{{image}}" alt="user" />
</div>
